module.exports = __webpack_public_path__ + "assets/images/project/head/Margielyn_Didal.jpg?v=9a44e9ec";